// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_3riFTObo","menu":"_2B0UF6U1","backdrop":"_2LsvVk-s","appear":"EyMw86-Z","content":"_1_HZuO7I","header":"_3cMUuxPR","logo-link":"_1CxZSSEQ","logo":"_2UL_yRGJ","nav":"n4seMm8L","is-selected":"_2CEsQXR-","social-links":"_3YHTpCUd","is-visible":"_3C5H8oSR"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/components/MobileMenu/MobileMenu.styl
// module id = 221
// module chunks = 0